import { useRef } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";
import { LvMatchValue } from "../LvMatchValue";
import { LvMatchPopover } from "./LvMatchPopover";
import { useLvMatchEditor } from "./useLvMatchEditor";
import type { LvMatchEditorProps } from "./types";

export const LvMatchEditor = ({
  lvMatch,
  boqPositions,
  onSave,
}: LvMatchEditorProps) => {
  const { t } = useTranslation();
  const triggerRef = useRef<HTMLButtonElement>(null);

  const editor = useLvMatchEditor({ lvMatch, boqPositions, onSave });

  return (
    <div className="relative min-w-0">
      <button
        ref={triggerRef}
        type="button"
        onClick={() =>
          editor.isEditing ? editor.closeEditor() : editor.openEditor()
        }
        className={clsx(
          "relative w-full flex min-w-0 items-center justify-center rounded px-3",
        )}
        aria-label={t("smartSurveyor.lvMatchEditor.edit")}
      >
        <div className="min-w-0">
          <LvMatchValue lvMatch={lvMatch} />
        </div>
        <ChevronDown
          size={16}
          className={clsx(
            "absolute -right-1 shrink-0 text-gray-600 transition-transform duration-200",
            editor.isEditing && "rotate-180",
          )}
        />
      </button>
      <LvMatchPopover anchorRef={triggerRef} editor={editor} />
    </div>
  );
};
